(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterAntragPruefenController', ReiterAntragPruefenController);

    ReiterAntragPruefenController.$inject = [
        '$scope',
        '$log',
        'lodash',
        'NavigationService',
        'BasisAngebotService',
        'LoadingIndicatorService'
    ];
    function ReiterAntragPruefenController($scope, $log, _, NavigationService, BasisAngebotService, LoadingIndicatorService) {
        var vm = this,
            angebotVm = $scope.angebotVm;

        $log.debug('ReiterAntragPruefenController', vm);

        vm.onSubmit = onSubmit;
        vm.isKontaktErlaubtPartner = isKontaktErlaubtPartner;

        activate();

        function activate() {}
        function onSubmit($event) {
            var buttonName = _.get($event, 'submitter.name');

            BasisAngebotService.mapFormToServiceData(angebotVm.angebotModel.formData, angebotVm.angebotModel.angebot, angebotVm.angebotModel.angebotInitial);

            if (!$scope.antragPruefenVm.antragPruefenForm.$valid || !BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANTRAG')) {
                $event.preventDefault();
                return false;
            }

            if (_.includes([
                'VERTRAG'
            ], buttonName)) {
                LoadingIndicatorService.addInProgress();

                BasisAngebotService.uebernehmeAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller', 'postempfaenger');

                BasisAngebotService.erzeugeVertrag({
                    tarifkuerzel: angebotVm.angebotModel.tarif.tarifkuerzel,
                    angebot: angebotVm.angebotModel.angebot,
                    formData: angebotVm.angebotModel.formData,
                    angebotInitial: angebotVm.angebotModel.angebotInitial
                }).then(function (data) {
                    if (data.angebot) {
                        angebotVm.angebotModel.angebot = angular.merge({}, data.angebot);
                    }
                    NavigationService.goToStep('rechner.abschluss', {
                        formValidation: true,
                        ignoreFollowingCheck: true,
                        apiNachrichten: data.nachrichten
                    });

                    LoadingIndicatorService.removeInProgress();
                }).catch(function (error) {
                    $log.debug('erzeugeVertrag FAILURE', error);

                    LoadingIndicatorService.removeInProgress();
                });
            }
        }
        function isKontaktErlaubtPartner() {
            return (
                angebotVm.isKontaktErlaubtPartner &&
                angebotVm.isPrivatPerson
            );
        }
    }
})();
